module.exports = {
      id: "automobile-usage",
      viewBox: "0 0 31.664 23.083",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#automobile",
      toString: function () {
        return this.url;
      }
    }